import * as types from '../costants/ActionTypes'


export const setPaymentMethod = (method, title) => ({
  type: types.SET_PAYMENT_METHOD,
  method: method,
  title: title,
});

export const setInvoiceData = data => ({
  type: types.SET_INVOICE_DATA,
  data
});

export const setPaymentData = data => ({
  type: types.SET_PAYMENT_DATA,
  data
});

